export const GeneralErrorBoundary = () => {
  return (
    <div
      style={{
        // reset
        margin: 0,
        border: 0,
        fontSize: "100%",
        font: "inherit",
        verticalAlign: "baseline",

        padding: "5rem",
        textAlign: "center",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <h1
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "1rem",
        }}
      >
        Something went wrong
      </h1>
      <p>Our team has been notified and will fix it as soon as possible.</p>

      <a href="javascript:history.back()">Go Back</a>
    </div>
  );
};
